/* eslint-disable no-unused-vars */
import axios from 'axios';
import apiEndpoints from '../globals/apiEndpoints';
import MockApi from './MockApi';
import marksModels from '../../fixtures/apiResponses/searchMarksModels.json';
import modifications from '../../fixtures/apiResponses/modifications.json';
import oilFilter from '../../fixtures/apiResponses/oilFilter.json';
import recommendedOil from '../../fixtures/apiResponses/recommendedOil.json';
import airFilter from '../../fixtures/apiResponses/airFilter.json';
import salonFilter from '../../fixtures/apiResponses/salonFilter.json';
import changeFilter from '../../fixtures/apiResponses/changeFilter.json';

export default class Cars {
	static fetchAll() {
		return axios.get(apiEndpoints.marksModels)
		.then(response => response.data)
		.catch((error) => {
			console.log('Error ' + error.message)
		  });
		//return MockApi.get({ data: marksModels, timeout: 1000 });
	}
	static fetchModifications(mark, model)
	{
		let url = apiEndpoints.modifications + '?mark_id=' + encodeURIComponent(mark) + '&model_id=' + encodeURIComponent(model);
		return axios.get(url)
		.then(response => response.data)
		.catch((error) => {console.log('Error ' + error.message)});
	}
	static fetchOilFilter(id) {
		return axios.get(`${apiEndpoints.oilFilter}?identfier=${id}`)
			.then(response => response.data)
			.catch((error) => {
				console.log('Error ' + error.message)
		  	});
		//return MockApi.get({ data: oilFilter, timeout: 200 });
	}
	static fetchRecommendedOil(id) {
		return axios.get(`${apiEndpoints.recommendedOil}?identfier=${id}`)
			.then(response => response.data)
			.catch((error) => {
				console.log('Error ' + error.message)
			});
	}
	static fetchAirFilter(id) {
		return axios.get(`${apiEndpoints.airFilter}?identfier=${id}`)
			.then(response => response.data)
			.catch((error) => {
				console.log('Error ' + error.message)
			});
		//return MockApi.get({ data: airFilter, timeout: 200 });
	}
	static fetchSalonFilter(id) {
		return axios.get(`${apiEndpoints.salonFilter}?identfier=${id}`)
			.then(response => response.data)
			.catch((error) => {
				console.log('Error ' + error.message)
			});
		//return MockApi.get({ data: salonFilter, timeout: 200 });
	}
	static fetchChangePrice() {
		return axios.get(apiEndpoints.changeFilter).then(response => response.data);
		//return MockApi.get({ data: changeFilter, timeout: 50 });
	}
}
